<template>
  <div class="tp_body">
		<div class="tp_b_top">
			<infoA :userid="userid" :oid="oid"></infoA>
			<!-- <panelA :userid="userid" :oid="oid" :org="org"></panelA> -->
		</div>
		<div class="tp_b_bottom">
			<testA :userid="userid" :oid="oid"></testA>
		</div>
    <!-- <div class="tp_left">
        <infoA :userid="userid" :oid="oid"></infoA>
        <panelA :userid="userid" :oid="oid" :org="org"></panelA>
    </div> -->
    <!-- <div class="tp_right">
        <testA :userid="userid" :oid="oid"></testA>
    </div> -->
  </div>
</template>

<script>
import infoA from './info/index.vue'
import panelA from './panel/index.vue'
import testA from './test/index.vue'

export default {
    name:'testPerson',
    components: {
        infoA,
        panelA,
        testA
    },
    data() {
        return {
            userid: this.$route.query.userid,
            oid: this.$route.query.oid,
            org: this.$route.query.org,
            role: this.$route.query.role,
        }
    },
    methods: {

    },
}
</script>

<style scoped>
    .tp_body{
        width: 100%;
        height: 100%;
        min-height: 820px;
        /* display: flex; */
        /* justify-content: center; */
        /* align-items: center; */
        padding:0px;
        box-sizing: border-box;
    }

		.tp_b_top{
			width: 100%;
			height: 130px;
		}

		.tp_b_bottom{
			width: 100%;
			height: calc(100% - 130px);
			overflow: auto;
		}

    /* .tp_left{
        width: 230px;
        height: 100%;
    }
    .tp_right{
        width: calc(100% - 230px - 10px);
        margin: 0 0 0 10px;
        height: 100%;
    } */

</style>


// WEBPACK FOOTER //
// src/components/pages/testPerson/index.vue